/* @ngInject */
function SvgCircleLoaderController ($scope, $timeout) {
  var ctrl = this

  ctrl.isStateHovered = false

  ctrl.getDashOffset = function () {
    return ((100 - ctrl.percentage) / 100) * (Math.PI * 2 * 90) + 'px'
  }

  ctrl.$onInit = function () {
    this.pi = Math.PI
    this.width = this.height = '4em'
  }

  ctrl.$onChanges = function (changes) {
    if (changes.percentage) {
      this.completed = changes.percentage.currentValue === 100
    }
  }

  $scope.$watch(function () { return ctrl.isStateHovered }, function (newValue) {
    if (newValue) {
      jQuery('.counter .times.icon').css({
        visibility: 'visible'
      })
    } else {
      jQuery('.counter .times.icon').css({
        visibility: 'hidden'
      })
    }
  })

  const deregisterUploadtableMinimize = $scope.$on('uploadtable.minimize', function (evt, isVisible) {
    if (!isVisible) {
      return
    }

    $timeout(() => {
      jQuery('svg.loader.upload-table-loader').css({
        overflow: 'unset'
      })
    }, 10, false)

    $timeout(() => {
      jQuery('svg.loader.upload-table-loader').css({
        overflow: 'hidden'
      })
    }, 50, false)
  })

  $scope.$on('$destroy', function () {
    deregisterUploadtableMinimize()
  })
}

export { SvgCircleLoaderController }
